var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.03 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8dc3ea;}.b{fill:#1a2345;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256,32c141.4,0,256,93.1,256,208,0,45.1-17.7,86.8-47.7,120.8,1.9,24.5,11.4,46.3,21.4,62.9a192.67,192.67,0,0,0,15.2,21.6c2.1,2.6,3.8,4.5,4.9,5.7.6.7,1,1.1,1.3,1.4l.3.3h0A16,16,0,0,1,496,480c-28.7,0-57.6-8.9-81.6-19.3a296.19,296.19,0,0,1-54.3-30.6A306.18,306.18,0,0,1,256,448C114.57,448,0,354.9,0,240S114.57,32,256,32Z",
    transform: "translate(0.03 -32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.71,130.92a29.46,29.46,0,0,1,41.67,0l26,26-52.48,52.44-26-26a29.47,29.47,0,0,1,0-41.66l10.78-10.77ZM353.1,284.59a25.6,25.6,0,0,1,6.53,11.14l13.68,47.88a11,11,0,0,1-13.68,13.67l-47.87-13.67a25.88,25.88,0,0,1-11.15-6.54L183.26,219.77l52.49-52.48,117.3,117.35Z",
    transform: "translate(0.03 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.10f74de443073a02531b934285d102cd.svg";
export { ForwardRef as ReactComponent };